import { NgModule } from "@angular/core";

import { Routes, RouterModule } from "@angular/router";

import { CollegeCourseComponent } from "./college-courses/college-courses-add.component";

import { CollegeFacilityComponent } from "./college-facility/college-facility-add.component";

import { CollegeVideosComponent } from "./college-videos/college-videos-add.component";

import { CollegeOtherComponent } from "./college-other/college-other-add.component";

import { AuthGuard } from "../../_helper/auth.guard";

import { CollegeInfoCreateComponent } from "./college-info/college-info-create/college-info-create.component";

import { CollegeFormCreateComponent } from "./college-form/college-form-create/college-form-create.component";

import { CollegeRankingCreateComponent } from "./college-ranking/college-ranking-create/college-ranking-create.component";

import { CollegeApplicationCreateComponent } from "./college-application/college-application-create/college-application-create.component";

import { CollegeContactCreateComponent } from "./college-contact/college-contact-create/college-contact-create.component";

import { CollegeAddressCreateComponent } from "./college-address/college-address-create/college-address-create.component";

import { CollegeEntranceexamCreateComponent } from "./college-entranceexam/college-entranceexam-create/college-entranceexam-create.component";

import { CollegeAccreditationCreateComponent } from "./college-accreditation/college-accreditation-create/college-accreditation-create.component";

import { CollegeReviewsCreateComponent } from "./college-reviews/college-reviews-create/college-reviews-create.component";

import { CollegeNewsCreateComponent } from "./college-news/college-news-create/college-news-create.component";

import { CollegeUniversityCreateComponent } from "./college-university/college-university-create/college-university-create.component";

import { CollegeGalleryCreateComponent } from "./college-gallery/college-gallery-create/college-gallery-create.component";

import { CollegeScholarshipCreateComponent } from "./college-scholarship/college-scholarship-create/college-scholarship-create.component";

import { CollegePlacementCreateComponent } from "./college-placement/college-placement-create/college-placement-create.component";

import { CollegeDocumentCreateComponent } from "./college-document/college-document-create/college-document-create.component";

import { CollegeInfoDetailsCreateComponent } from "./college-info-details/college-info-details-create/college-info-details-create.component";

import { CollegeBranchDetailsCreateComponent } from "./college-branch-details/college-branch-details-create/college-branch-details-create.component";

import { CollegeCourseDetailsCreateComponent } from "./college-course-details/college-course-details-create/college-course-details-create.component";

import { CollegeInfoListComponent } from "./college-info/college-info-list/college-info-list.component";

import { CollegeFormListComponent } from "./college-form/college-form-list/college-form-list.component";

import { CollegeDocumentListComponent } from "./college-document/college-document-list/college-document-list.component";

import { CollegeAccreditationListComponent } from "./college-accreditation/college-accreditation-list/college-accreditation-list.component";

import { CollegeReviewsListComponent } from "./college-reviews/college-reviews-list/college-reviews-list.component";

import { CollegeNewsListComponent } from "./college-news/college-news-list/college-news-list.component";

import { CollegeAddressListComponent } from "./college-address/college-address-list/college-address-list.component";

import { CollegeRankingListComponent } from "./college-ranking/college-ranking-list/college-ranking-list.component";

import { CollegeUniversityListComponent } from "./college-university/college-university-list/college-university-list.component";

import { CollegeGalleryListComponent } from "./college-gallery/college-gallery-list/college-gallery-list.component";

import { CollegeScholarshipListComponent } from "./college-scholarship/college-scholarship-list/college-scholarship-list.component";

import { CollegePlacementListComponent } from "./college-placement/college-placement-list/college-placement-list.component";

import { CollegeApplicationListComponent } from "./college-application/college-application-list/college-application-list.component";

import { CollegeContactListComponent } from "./college-contact/college-contact-list/college-contact-list.component";

import { CollegeEntranceexamListComponent } from "./college-entranceexam/college-entranceexam-list/college-entranceexam-list.component";

import { CollegeInfoDetailsListComponent } from "./college-info-details/college-info-details-list/college-info-details-list.component";

import { CollegeBranchDetailsListComponent } from "./college-branch-details/college-branch-details-list/college-branch-details-list.component";

import { CollegeCourseDetailsListComponent } from "./college-course-details/college-course-details-list/college-course-details-list.component";

import { LogoComponent } from "./logo/logo.component";
import { CollegeApplicationViewComponent } from "./college-application/college-application-view/college-application-view.component";
import { CollegeApplicationComponent } from "./college-application/college-view-application/college-application.component";
import { CollegeApprovalListComponent } from "./college-form/waiting-for-approval/college-approval-list.component";

const routes: Routes = [
  {
    path: "",
    children: [
      {
        path: "add-college-info",
        component: CollegeInfoCreateComponent,
        data: {
          title: "Add College Info",
          breadcrumb: "Add College Info",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-college-form",
        component: CollegeFormCreateComponent,
        data: {
          title: "Add College Form",
          breadcrumb: "Add College Form",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-college-contact",
        component: CollegeContactCreateComponent,
        data: {
          title: "Add College Contact",
          breadcrumb: "Add College Contact",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-college-contact/:id",
        component: CollegeContactCreateComponent,
        data: {
          title: "Add College Contact ",
          breadcrumb: "Add College Contact ",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-college-ranking",
        component: CollegeRankingCreateComponent,
        data: {
          title: "Add College Ranking",
          breadcrumb: "Add College Ranking",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-college-ranking/:id",
        component: CollegeRankingCreateComponent,
        data: {
          title: "Add College Ranking",
          breadcrumb: "Add College Ranking",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-college-university",
        component: CollegeUniversityCreateComponent,
        data: {
          title: "Add College University",
          breadcrumb: "Add College University",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-college-university/:id",
        component: CollegeUniversityCreateComponent,
        data: {
          title: "Add College University ",
          breadcrumb: "Add College University ",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-college-gallery",
        component: CollegeGalleryCreateComponent,
        data: {
          title: "Add College Gallery",
          breadcrumb: "Add College Gallery",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-college-gallery/:id",
        component: CollegeGalleryCreateComponent,
        data: {
          title: "Add College Gallery",
          breadcrumb: "Add College Gallery",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-college-scholarship",
        component: CollegeScholarshipCreateComponent,
        data: {
          title: "Add College Scholarship",
          breadcrumb: "Add College Scholarship",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-college-scholarship/:id",
        component: CollegeScholarshipCreateComponent,
        data: {
          title: "Add College Scholarship",
          breadcrumb: "Add College Scholarship",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-college-placement",
        component: CollegePlacementCreateComponent,
        data: {
          title: "Add College Placement",
          breadcrumb: "Add College Placement",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-college-placement/:id",
        component: CollegePlacementCreateComponent,
        data: {
          title: "Add College Placement",
          breadcrumb: "Add College Placement",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-college-application",
        component: CollegeApplicationCreateComponent,
        data: {
          title: "Add College Application",
          breadcrumb: "Add College Application",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-college-application/:id",
        component: CollegeApplicationCreateComponent,
        data: {
          title: "Add College Application",
          breadcrumb: "Add College Application",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-college-address",
        component: CollegeAddressCreateComponent,
        data: {
          title: "Add College Address",
          breadcrumb: "Add College Address",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-college-address/:id",
        component: CollegeAddressCreateComponent,
        data: {
          title: "Add College Address ",
          breadcrumb: "Add College Address ",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "view-college-address/:id",
        component: CollegeApplicationViewComponent,
        data: {
          title: "View College Address ",
          breadcrumb: "View College Address ",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-college-accreditation",
        component: CollegeAccreditationCreateComponent,
        data: {
          title: "Add College Accreditation",
          breadcrumb: "Add College Accreditation",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-college-accreditation/:id",
        component: CollegeAccreditationCreateComponent,
        data: {
          title: "Add College Accreditation",
          breadcrumb: "Add College Accreditation",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-college-reviews",
        component: CollegeReviewsCreateComponent,
        data: {
          title: "Add College Reviews",
          breadcrumb: "Add College Reviews",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-college-reviews/:id",
        component: CollegeReviewsCreateComponent,
        data: {
          title: "Add College Reviews",
          breadcrumb: "Add College Reviews",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-college-news",
        component: CollegeNewsCreateComponent,
        data: {
          title: "Add College News",
          breadcrumb: "Add College News",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-college-news/:id",
        component: CollegeNewsCreateComponent,
        data: {
          title: "Add College News",
          breadcrumb: "Add College News",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-college-entranceexam",
        component: CollegeEntranceexamCreateComponent,
        data: {
          title: "Add College Entranceexam",
          breadcrumb: "Add College Entranceexam",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-college-entranceexam/:id",
        component: CollegeEntranceexamCreateComponent,
        data: {
          title: "Add College Entranceexam",
          breadcrumb: "Add College Entranceexam",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-college-document",
        component: CollegeDocumentCreateComponent,
        data: {
          title: "Add College Document",
          breadcrumb: "Add College Document",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-college-document/:id",
        component: CollegeDocumentCreateComponent,
        data: {
          title: "Add College Document",
          breadcrumb: "Add College Document",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-college-branch-details",
        component: CollegeBranchDetailsCreateComponent,
        data: {
          title: "Add College Branch Details",
          breadcrumb: "Add College Branch Details",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-college-branch-details/:id",
        component: CollegeBranchDetailsCreateComponent,
        data: {
          title: "Add College Branch Details",
          breadcrumb: "Add College Branch Details",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "edit-college-branch-details/:id",
        component: CollegeBranchDetailsCreateComponent,
        data: {
          title: "Edit College Branch Info",
          breadcrumb: "Edit College Branch Info",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-college-course-details",
        component: CollegeCourseDetailsCreateComponent,
        data: {
          title: "Add College Course Details",
          breadcrumb: "Add College Course Details",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-college-course-details/:id",
        component: CollegeCourseDetailsCreateComponent,
        data: {
          title: "Add College Course Details",
          breadcrumb: "Add College Course Details",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "edit-college-course-details/:id",
        component: CollegeCourseDetailsCreateComponent,
        data: {
          title: "Edit College Course Info",
          breadcrumb: "Edit College Course Info",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "edit-college-contact/:id",
        component: CollegeContactCreateComponent,
        data: {
          title: "Edit College Contact",
          breadcrumb: "Edit College Contact",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "edit-college-university/:id",
        component: CollegeUniversityCreateComponent,
        data: {
          title: "Edit College University",
          breadcrumb: "Edit College University",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "edit-college-info/:id",
        component: CollegeInfoCreateComponent,
        data: {
          title: "Edit College Info",
          breadcrumb: "Edit College Info",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "edit-college-form/:id",
        component: CollegeFormCreateComponent,
        data: {
          title: "Edit College Form",
          breadcrumb: "Edit College Form",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "edit-college-ranking/:id",
        component: CollegeRankingCreateComponent,
        data: {
          title: "Edit College Ranking",
          breadcrumb: "Edit College Ranking",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "edit-college-application/:id",
        component: CollegeApplicationCreateComponent,
        data: {
          title: "Edit College Application",
          breadcrumb: "Edit College Application",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "view-college-application/:id",
        component: CollegeApplicationComponent,
        data: {
          title: "View College Application",
          breadcrumb: "View College Application",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "edit-college-branch-details/:id",
        component: CollegeBranchDetailsCreateComponent,
        data: {
          title: "Edit College BranchDetails",
          breadcrumb: "Edit College BranchDetails",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "edit-college-gallery/:id",
        component: CollegeGalleryCreateComponent,
        data: {
          title: "Edit College Gallery",
          breadcrumb: "Edit College Gallery",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "edit-college-scholarship/:id",
        component: CollegeScholarshipCreateComponent,
        data: {
          title: "Edit College Scholarship",
          breadcrumb: "Edit College Scholarship",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "edit-college-placement/:id",
        component: CollegePlacementCreateComponent,
        data: {
          title: "Edit College Placement",
          breadcrumb: "Edit College Placement",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "edit-college-address/:id",
        component: CollegeAddressCreateComponent,
        data: {
          title: "Edit College Address",
          breadcrumb: "Edit College Address",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "edit-college-accreditation/:id",
        component: CollegeAccreditationCreateComponent,
        data: {
          title: "Edit College Accreditation",
          breadcrumb: "Edit College Accreditation",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "edit-college-reviews/:id",
        component: CollegeReviewsCreateComponent,
        data: {
          title: "Edit College Reviews",
          breadcrumb: "Edit College Reviews",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "edit-college-news/:id",
        component: CollegeNewsCreateComponent,
        data: {
          title: "Edit College News",
          breadcrumb: "Edit College News",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "edit-college-entranceexam/:id",
        component: CollegeEntranceexamCreateComponent,
        data: {
          title: "Edit College Entranceexam",
          breadcrumb: "Edit College Entranceexam",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "edit-college-document/:id",
        component: CollegeDocumentCreateComponent,
        data: {
          title: "Edit College Document",
          breadcrumb: "Edit College Document",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "college-info-list",
        component: CollegeInfoListComponent,
        data: {
          title: "College Info List",
          breadcrumb: "College Info List",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "college-form-list",
        component: CollegeFormListComponent,
        data: {
          title: "Waiting For Approval List",
          breadcrumb: "Waiting For Approval List",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "college-form-list/:id",
        component: CollegeFormListComponent,
        data: {
          title: "Waiting For Approval List",
          breadcrumb: "Waiting For Approval List",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "waiting-for-approval",
        component: CollegeApprovalListComponent,
        data: {
          title: "Waiting For Approval List",
          breadcrumb: "Waiting For Approval List",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "college-ranking-list",
        component: CollegeRankingListComponent,
        data: {
          title: "College Ranking List",
          breadcrumb: "College Ranking List",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "college-application-list",
        component: CollegeApplicationListComponent,
        data: {
          title: "College Application List",
          breadcrumb: "College Application List",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "college-contact-list",
        component: CollegeContactListComponent,
        data: {
          title: "College Contact List",
          breadcrumb: "College Contact List",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "college-university-list",
        component: CollegeUniversityListComponent,
        data: {
          title: "College University List",
          breadcrumb: "College University List",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "college-gallery-list",
        component: CollegeGalleryListComponent,
        data: {
          title: "College Gallery List",
          breadcrumb: "College Gallery List",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "college-scholarship-list",
        component: CollegeScholarshipListComponent,
        data: {
          title: "College Scholarship List",
          breadcrumb: "College Scholarship List",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "college-placement-list",
        component: CollegePlacementListComponent,
        data: {
          title: "College Placement List",
          breadcrumb: "College Placement List",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "college-address-list",
        component: CollegeAddressListComponent,
        data: {
          title: "College Address List",
          breadcrumb: "College Address List",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "college-branch-details-list",
        component: CollegeBranchDetailsListComponent,
        data: {
          title: "College Branch Details List",
          breadcrumb: "College Branch Details List",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "college-course-details-list",
        component: CollegeCourseDetailsListComponent,
        data: {
          title: "College Course Details List",
          breadcrumb: "College Course Details List",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-college-details-info",
        component: CollegeInfoDetailsCreateComponent,
        data: {
          title: "Add College Details Info",
          breadcrumb: "Add College Details Info",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "add-college-details-info/:id",
        component: CollegeInfoDetailsCreateComponent,
        data: {
          title: "Add College Details Info",
          breadcrumb: "Add College Details Info",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "edit-college-info-details/:id",
        component: CollegeInfoDetailsCreateComponent,
        data: {
          title: "Edit College Details Info",
          breadcrumb: "Edit College Details Info",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "college-info-details-list",
        component: CollegeInfoDetailsListComponent,
        data: {
          title: "College Info Details List",
          breadcrumb: "College Info Details List",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "college-accreditation-list",
        component: CollegeAccreditationListComponent,
        data: {
          title: "College Accreditation List",
          breadcrumb: "College Accreditation List",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "college-reviews-list",
        component: CollegeReviewsListComponent,
        data: {
          title: "College Reviews List",
          breadcrumb: "College Reviews List",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "college-news-list",
        component: CollegeNewsListComponent,
        data: {
          title: "College News List",
          breadcrumb: "College News List",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "college-entranceexam-list",
        component: CollegeEntranceexamListComponent,
        data: {
          title: "College Entranceexam List",
          breadcrumb: "College Entranceexam List",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "college-document-list",
        component: CollegeDocumentListComponent,
        data: {
          title: "College Document List",
          breadcrumb: "College Document List",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "logo/:id",
        component: LogoComponent,
        data: {
          title: "Update Logo",
          breadcrumb: "Update Logo",
        },
        canActivate: [AuthGuard],
      },

      {
        path: "college-courses/:id",
        component: CollegeCourseComponent,
        data: {
          title: "Add college Course",
          breadcrumb: "Add College Course",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "edit-college-courses/:id",
        component: CollegeCourseComponent,
        data: {
          title: "Edit college Course",
          breadcrumb: "Edit College Course",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "college-details/add-college-facility",
        component: CollegeFacilityComponent,
        data: {
          title: "Add college facility",
          breadcrumb: "Add College facility",
        },
        canActivate: [AuthGuard],
      },
      {
        path: "college-details/add-college-other",
        component: CollegeOtherComponent,
        data: {
          title: "Add college Other Info",
          breadcrumb: "Add College Other Info",
        },
        canActivate: [AuthGuard],
      },

      {
        path: "videos/:id",
        component: CollegeVideosComponent,
        data: {
          title: "College videos",
          breadcrumb: "College videos",
        },
        canActivate: [AuthGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CollegeDetailsRoutingModule {}
